import React, {Component} from 'react';
import cn from 'classnames';

import './style.css';

export const ICON_MAIL = 'MAIL';
export const ICON_PHONE = 'PHONE';

export default class ContactInfo extends Component {

    render() {
        const iconClass = cn(
            'ContactInfo__icon',
            this.props.icon === ICON_MAIL ? 'ContactInfo__icon--mail' : '',
            this.props.icon === ICON_PHONE ? 'ContactInfo__icon--phone' : '',
        );
        return (
            <div className="ContactInfo">
                <span className={iconClass}></span>
                <span className="ContactInfo__text">{this.props.children}</span>
            </div>
        );
    }
}